export default "__VITE_ASSET__DKv9sUIa__"